import React from 'react';
import { WidgetViewModel } from '../../../../viewModel/viewModel';
import { PremiumDialog } from './PremiumDialog/PremiumDialog';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { WidgetActions } from '../../../../actions/actions';
import { DialogType } from '../../../../viewModel/dialogViewModel/dialogViewModel';
import { NavigationTarget } from '../../../../actions/navigateToNextPage/consts';

export type DialogProps = {
  widgetActions: WidgetActions;
  widgetViewModel: WidgetViewModel;
};

const ServicesPreferencesModal = React.lazy(() =>
  import('@wix/bookings-services-preferences-modal').then((module) => ({
    default: module.ServicesPreferencesModal,
  })),
);

export const Dialog: React.FC<DialogProps> = (props) => {
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();
  const { widgetActions, widgetViewModel } = props;
  const { dialogViewModel } = widgetViewModel;
  const { onPreferencesModalServiceSelected } = widgetActions;

  if (DialogType.Premium === dialogViewModel.type) {
    return (
      <PremiumDialog
        isOpen={dialogViewModel.isOpen}
        content={t('user-message.not-bookable')}
        confirmationButtonLabel={t('user-message.action-ok-label')}
        onClose={() => widgetActions.onDialogClose()}
      />
    );
  }

  if (
    DialogType.ServicePreferences === dialogViewModel.type &&
    dialogViewModel.isOpen
  ) {
    return (
      <React.Suspense fallback={null}>
        <ServicesPreferencesModal
          {...dialogViewModel.data!}
          t={t}
          onConfirm={(basket) => {
            widgetActions.navigateToNextPage({
              basket,
              target: NavigationTarget.CALENDAR_PAGE,
            });
            widgetActions.onDialogClose();
          }}
          onClose={() => widgetActions.onDialogClose()}
          onServiceSelected={onPreferencesModalServiceSelected}
          isMobile={isMobile}
          constrains={{
            maxServices: 5,
          }}
        />
      </React.Suspense>
    );
  }

  return null;
};
